import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FaqAccordion({ items, idPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {items.map((item, i) => (
        <AccordionItem
          key={i}
          value={`${idPrefix}-${i}`}
          className="border-b border-light-gray"
          data-testid={`faq-item-${i}`}
        >
          <AccordionTrigger className="py-5 font-heading text-base font-bold text-anthracite hover:no-underline md:text-lg">
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="pb-5 text-base leading-relaxed text-mid-gray">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
